import React from 'react'

import BuilderForm from '../components/builder/BuilderForm'
import CondoForm from '../components/condo/CondoForm'
import { MiniCondoBuilderForm } from '../components/MiniCondoBuilderReport'

const CondoBuilderForms = ({ minMode, whichReport, handleSubmit, handleChange, handleInvalid, handleReset, condoReport,
  homeBuilder, values, errors, stations }) =>
  <div className='condo-builder-forms'>
    {minMode ?
      <MiniCondoBuilderForm
        whichReport={whichReport}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        handleInvalid={handleInvalid}
        handleReset={handleReset}
        report={whichReport === 'Condo' ? condoReport : homeBuilder}
        name={values.name}
        stateCode={values.stateCode}
        errors={errors} />
      : whichReport === 'Condo' ?
        <CondoForm
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          handleInvalid={handleInvalid}
          handleReset={handleReset}
          condoReport={condoReport}
          values={values}
          errors={errors}
          stations={stations} />
        : <BuilderForm
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          handleInvalid={handleInvalid}
          handleReset={handleReset}
          homeBuilder={homeBuilder}
          values={values}
          errors={errors}
          stations={stations} />}
  </div>

export default CondoBuilderForms